import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

import { PdfViewPropsType } from '../../types'

export const PdfView: React.FC<PdfViewPropsType> = (props) => {
  return (
    <>
      <div ref={props.viewerRef}>
        <Document
          file={props.pdfUrl}
          onLoadSuccess={props.onDocumentLoadSuccess}
          options={{
            cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
            cMapPacked: true,
            // 悪意ある PDF のフォント経由で任意 JS が実行される脆弱性 (CVE-2024-4367) の緩和。
            // pdfjs-dist 4.2.67 未満では eval が既定で有効なため明示的に無効化する。
            isEvalSupported: false,
          }}
        >
          <Page pageNumber={props.currentPage} />
        </Document>
      </div>
    </>
  )
}
